import * as React from 'react';
import Svg, {SvgProps, Circle, Ellipse} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={20}
    height={20}
    viewBox={'0 0 20 20'}
    {...props}
    fill={'none'}
    stroke={'none'}>
    <Circle cx={10} cy={10} r={9.5} stroke={props.fill || '#fff'} />
    <Ellipse cx={10} cy={15} fill={props.fill || '#fff'} rx={6} ry={5} />
    <Circle cx={10} cy={6} r={3} fill={props.fill || '#fff'} />
  </Svg>
);
export default SvgComponent;
